import { DetentionSummary } from "../DetentionSummary";
import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDetentionHistoryTable extends Layout {
    layoutDetentionSummary: DetentionSummary;
    sourceDetentionHistoryLookup: DataSource;
    tableDetentionHistory: Table;
}
